import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.387 3.44h9.226c1.107 0 2 .893 2 2v2.213"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.493 1.333 2.387 3.44l2.106 2.107M13.613 12.56H4.387c-1.107 0-2-.893-2-2V8.347"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11.507 14.666 2.107-2.106-2.107-2.107"
    />
  </svg>
)
export default SvgComponent
